import { createSelector } from "reselect";
import { isEmpty } from "lodash";
import moment from "moment";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;

  if (isEmpty(profile)) {
    return null;
  }

  return profile.birthDate;
};
//VERIFY IF THE JWT IS SET
const getMyBirthDate = createSelector(getData, birthDate => birthDate);
export default getMyBirthDate;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyBirthDate.js